var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex min-vh-100 justify-content-center flex-column ds-background-primary"},[_c('div',{staticClass:"text-center"},[_c('Login')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }